import * as React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanelComponent(props: any) {
  const { children, value, index, ...other } = props;
  const [style, setStyle] = React.useState({ padding: '20px 10px' })

  React.useEffect(() => {
    if (props.disableMargin ?? false) {
      setStyle({ padding: '0' });
    }
  }, []);

  return (<div
      role="tabpanel"
      hidden={value !== index}
      id={`${props.tab}-tabpanel-${index}`}
      aria-labelledby={`${props.tab}-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{'padding': '15px'}}>
          {children}
        </div>
      )}
    </div>);
}

export default TabPanelComponent;